import { Http } from '../../utils/http'
import { Api as Config } from '../../utils/config'
import { IGetActivityInfoResponse } from './interface'

class Api {
    // 获取活动信息
    public static getActivityInfo(id: number) {
        const url = this.host + `/votecenter/groups?id=${id}`
        return Http.get<{}, IGetActivityInfoResponse>(url)
    }

    private static host = Config().host
}

export { Api }


// WEBPACK FOOTER //
// ./src/components/common/api.ts